import { useEffect, useState } from 'react';

interface VisibilityChangeOptions {
  onHidden?: () => void;
  onVisible?: () => void;
}

const getHiddenProperty = () => {
  return 'hidden' in document ? document.hidden : (document as any).webkitHidden;
};

export default function useVisibilityState(options?: VisibilityChangeOptions) {
  const [visible, setIsVisible] = useState(!document.hidden);

  useEffect(() => {
    const onChange = () => {
      const hidden = getHiddenProperty();
      setIsVisible(!hidden);
      if (hidden) {
        options?.onHidden && options.onHidden();
      } else {
        options?.onVisible && options.onVisible();
      }
    };
    setIsVisible(!getHiddenProperty());
    if ('hidden' in document) {
      document.addEventListener('visibilitychange', onChange);
    } else {
      // Fallback for browsers that do not support the Page Visibility API
      (document as Document).addEventListener('webkitvisibilitychange', onChange);
    }
    return () => {
      document.removeEventListener('visibilitychange', onChange);
      document.removeEventListener('webkitvisibilitychange', onChange);
    };
  }, [options]);

  return visible;
}
